export default __webpack_public_path__ + "static/media/04.e1bf7a98.jpg";